import styled from 'styled-components';
import { SCREEN_SIZE } from '../';
import { FontAddiWeightMedium } from '@addi/foundation/dist/web/fonts';
export const Container = styled.div `
    position: fixed;
    z-index: 101;
    right: 3%;
    bottom: ${({ bottom }) => bottom || '2%'};

    img {
        cursor: pointer;
    }

    p {
        font-weight: ${FontAddiWeightMedium};
    }

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        bottom: ${({ mobileBottom }) => mobileBottom || '2%'};
        right: 3%;
    }
`;
//# sourceMappingURL=WhatsAppButton.Styled.js.map